import { type TFunction } from 'i18next';

import { type SpecContractType } from '@/common/types/contract';

const rewards: Record<SpecContractType, string> = {
  Grand: '+50%',
  Custom: '+20%',
  Golden: '+50%',
  Blitz: '+50%',
};

const getTitles = (t: TFunction): Record<SpecContractType, string> => ({
  Grand: t('Ready for a Grand Contract?'),
  Custom: '',
  Golden: t('Ready for a Premium Contract?'),
  Blitz: t('Ready for a Blitz Contract?'),
});

const styles: Record<
  SpecContractType,
  { withReward: string; withoutReward: string }
> = {
  Grand: {
    withoutReward: 'mt-8',
    withReward: 'mt-9',
  },
  Custom: {
    withoutReward: '',
    withReward: '',
  },
  Golden: {
    withoutReward: 'mt-8',
    withReward: 'mt-9',
  },
  Blitz: {
    withoutReward: 'mt-4',
    withReward: 'mt-[37px]',
  },
};

export { getTitles, rewards, styles };
